import { Compass, MousePointerClick } from "lucide-react";
import { useDemoStore } from "@/store/useDemoStore";

export function ModeToggle() {
  const mode = useDemoStore((s) => s.settings.mode);
  const setMode = useDemoStore((s) => s.setMode);
  const guided = mode === "demo-guiada";
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        background: "var(--cc-gray-100)",
        border: "1px solid var(--cc-gray-200)",
        borderRadius: 8,
        padding: 3,
      }}
      data-testid="mode-toggle"
    >
      <button
        onClick={() => setMode("libre")}
        data-testid="mode-libre"
        title="Navegación libre con CRUD completo"
        style={{
          display: "flex", alignItems: "center", gap: 6,
          padding: "5px 10px", borderRadius: 6,
          background: !guided ? "white" : "transparent",
          border: !guided ? "1px solid var(--cc-gray-200)" : "1px solid transparent",
          color: !guided ? "var(--cc-navy)" : "var(--cc-gray-500)",
          fontSize: 12, fontWeight: 600,
          cursor: "pointer",
        }}
      >
        <MousePointerClick size={12} />
        Libre
      </button>
      <button
        onClick={() => setMode("demo-guiada")}
        data-testid="mode-guided"
        title="Demo guiada paso a paso del flujo EC1781"
        style={{
          display: "flex", alignItems: "center", gap: 6,
          padding: "5px 10px", borderRadius: 6,
          background: guided ? "white" : "transparent",
          border: guided ? "1px solid var(--cc-gray-200)" : "1px solid transparent",
          color: guided ? "var(--cc-navy)" : "var(--cc-gray-500)",
          fontSize: 12, fontWeight: 600,
          cursor: "pointer",
        }}
      >
        <Compass size={12} />
        Demo guiada
      </button>
    </div>
  );
}
